(function () {
  const $carousels = $('.tr-image-with-caption .tr-image-caption-slider');

  if (!$carousels.length) { return; }

  $carousels.each(function () {
    $(this)
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        rows: 0,
        focusOnSelect: true,
        infinite: true,
        centerPadding: '100px',
        mobileFirst: true,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        dots: true,
        responsive: [
          {
            breakpoint: 0,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            }
          }, {
            breakpoint: 576,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            }
          }, {
            breakpoint: 768,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            centerPadding: '200px',
            }
          }, {
            breakpoint: 992,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            centerPadding: '200px',
            }
          }, {
            breakpoint: 1200,
            settings: 'unslick'
          }
        ]
      });
  });
})();